module.exports = __webpack_public_path__ + "static/media/Kuva_2_3.a1d9da1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Kuva_2_3.png
// module id = 1396
// module chunks = 0